/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BatchSaveShowEventFeaturedStoreResponse,
    BatchShowEventFeaturedStoreRequest,
} from '../models';

export interface ShowEventFeaturedStoreApiControllerBatchSaveShowEventFeaturedStoresRequest {
    eventId: string;
    batchShowEventFeaturedStoreRequest: BatchShowEventFeaturedStoreRequest;
}

/**
 * 
 */
export class ShowEventFeaturedStoreApi extends runtime.BaseAPI {

    /**
     */
    async showEventFeaturedStoreApiControllerBatchSaveShowEventFeaturedStoresRaw(requestParameters: ShowEventFeaturedStoreApiControllerBatchSaveShowEventFeaturedStoresRequest): Promise<runtime.ApiResponse<BatchSaveShowEventFeaturedStoreResponse>> {
        if (requestParameters.eventId === null || requestParameters.eventId === undefined) {
            throw new runtime.RequiredError('eventId','Required parameter requestParameters.eventId was null or undefined when calling showEventFeaturedStoreApiControllerBatchSaveShowEventFeaturedStores.');
        }

        if (requestParameters.batchShowEventFeaturedStoreRequest === null || requestParameters.batchShowEventFeaturedStoreRequest === undefined) {
            throw new runtime.RequiredError('batchShowEventFeaturedStoreRequest','Required parameter requestParameters.batchShowEventFeaturedStoreRequest was null or undefined when calling showEventFeaturedStoreApiControllerBatchSaveShowEventFeaturedStores.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events/{eventId}/featured-stores:batch-save`.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters.eventId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.batchShowEventFeaturedStoreRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async showEventFeaturedStoreApiControllerBatchSaveShowEventFeaturedStores(requestParameters: ShowEventFeaturedStoreApiControllerBatchSaveShowEventFeaturedStoresRequest): Promise<BatchSaveShowEventFeaturedStoreResponse> {
        const response = await this.showEventFeaturedStoreApiControllerBatchSaveShowEventFeaturedStoresRaw(requestParameters);
        return await response.value();
    }

}
